import { CadCategory, CadCategoryRequest, CadCategoryResponse, CategoryBaseResponse } from '@shared/utils/category';

export class Category {
  constructor(
    public name: string,
    public retainDays: number,
    public useRetainDays: boolean,
    public isArchived: boolean,
    public isDefault: boolean,
    public cadCategories: CadCategory[],
    public appliedOnFiles: number,
    public uid: string,
    public description: string
  ) {}
}

export class CategoryResponse extends CategoryBaseResponse {
  constructor(
    Name: string,
    RetainDays: number,
    UseRetainDays: boolean,
    IsArchived: boolean,
    IsDefault: boolean,
    CadCategories: CadCategoryResponse[],
    AppliedOnFiles: number,
    UID: string,
    public Description: string
  ) {
    super(Name, RetainDays, UseRetainDays, IsArchived, IsDefault, CadCategories, AppliedOnFiles, UID);
  }
}

export class NewCategoryRequest {
  constructor(
    public Name: string,
    public RetainDays: number | null,
    public UseRetainDays: boolean,
    public IsDefault: boolean,
    public CadCategories: CadCategoryRequest[],
    public Description: string
  ) {}
}

export class UpdateCategoryRequest {
  constructor(
    public Name: string,
    public RetainDays: number | null,
    public UseRetainDays: boolean,
    public IsArchived: boolean,
    public IsDefault: boolean,
    public CadCategories: CadCategoryRequest[],
    public Description: string
  ) {}
}
